import { SiteMaterialDetail } from 'api';
import { RadioGroup } from 'form';
import { capitalizeString } from 'ui';

type Props = {
  siteMaterialDetail: SiteMaterialDetail;
};

const SELLER_LABEL = "Use Seller's Label as PO Product Description";
const SAFI_LABEL = 'Use Safi Product as PO Product Description';

const getSellerDescription = (siteMaterialDetail: SiteMaterialDetail) => {
  const materialName = siteMaterialDetail.material_product?.material_spec?.title || '';
  const sellerGrade = siteMaterialDetail.seller_label || 'N/A';
  const originName = capitalizeString(siteMaterialDetail.material_product?.material_origin?.type || '');
  let description = `${SELLER_LABEL}: ${materialName} ${sellerGrade}`;
  if (sellerGrade !== 'N/A' && originName) {
    description += ` - ${originName}`;
  }
  return description;
};

const getInternalDescription = (siteMaterialDetail: SiteMaterialDetail) => {
  const materialName = siteMaterialDetail.material_product?.material_spec?.title || '';
  const internalGrade = siteMaterialDetail.material_product?.material_grade?.name || '';
  const originName = capitalizeString(siteMaterialDetail.material_product?.material_origin?.type || '');
  let description = `${SAFI_LABEL}: ${materialName} ${internalGrade}`;
  if (siteMaterialDetail.material_product?.is_food_grade) {
    description += ' - Food Grade';
  }
  if (typeof siteMaterialDetail.material_product?.has_caps_and_labels === 'boolean') {
    const hasCapsAndLabels = siteMaterialDetail.material_product?.has_caps_and_labels ? 'w' : 'w/o';
    description += ` - ${hasCapsAndLabels} Caps and Labels`;
  }
  if (originName) {
    description += ` - ${originName}`;
  }
  return description;
};

export const IsInternalGradeShownToSeller = ({ siteMaterialDetail }: Props) => {
  const options = [
    {
      label: getInternalDescription(siteMaterialDetail),
      value: true,
    },
    {
      label: getSellerDescription(siteMaterialDetail),
      value: false,
    },
  ];

  return <RadioGroup name="is_internal_grade_shown_to_seller" options={options} />;
};
